"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnDTracker = void 0;
var trackerBase_1 = require("./trackerBase");
var DnDTracker = /** @class */ (function (_super) {
    __extends(DnDTracker, _super);
    function DnDTracker(handler, options) {
        var _this = _super.call(this, handler, options) || this;
        _this.dropHandlerBound = _this.dropHandler.bind(_this);
        return _this;
    }
    DnDTracker.prototype.subscribeToEvent = function (element) {
        if (element === void 0) { element = document; }
        element.addEventListener('drop', this.dropHandlerBound);
    };
    DnDTracker.prototype.unsubscribeFromEvent = function (element) {
        if (element === void 0) { element = document; }
        element.removeEventListener('drop', this.dropHandlerBound);
    };
    DnDTracker.prototype.dropHandler = function (event) {
        var _a;
        event.stopPropagation();
        event.preventDefault();
        var files = Array.from(((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) || []);
        this.uploadHandler(files);
    };
    return DnDTracker;
}(trackerBase_1.TrackerBase));
exports.DnDTracker = DnDTracker;
